module.exports = __webpack_public_path__ + "img/pro.be974362.png";